var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_vm.recruitment._id ? _c('v-container', [_c('recruitment-view-card', _vm._g(_vm._b({}, 'recruitment-view-card', {
    recruitment: _vm.recruitment
  }, false), {
    init: _vm.init
  }))], 1) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }